import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import wacToken from '@/libraries/design/foundations/token/src/wac-token';
import { Icon } from '@/libraries/wpl/foundations/src/icon';

type FilterCategories = 'app' | 'category' | 'status';

type FilterOptions = {
	committedActive: boolean;
	stagedActive: boolean;
};

type SubFilterObject = {
	[filter: string]: FilterOptions;
};

export type UniformFilterModalProps = {
	subFilter: FilterCategories;
	subFilterObject: SubFilterObject;
	updateFilterObject: (subFilterName: string) => void;
};

export const UniformFilterModal = ({
	subFilter,
	subFilterObject,
	updateFilterObject,
}: UniformFilterModalProps) => {
	return (
		<div
			css={uniformFilterModalStyle}
			className={subFilter}
			id="uniform-filter-modal-component-parent"
		>
			<div css={filterListContainerStyle}>
				{Object.keys(subFilterObject).map((filterOptionName: string, index: number) => {
					const filterObject = subFilterObject[filterOptionName] as FilterOptions;
					const active: boolean = filterObject.stagedActive;
					const optionId = `option-${subFilter.replace(/\s/g, '')}-${index}`;
					return (
						<label key={filterOptionName} htmlFor={optionId} css={filterRadioButtonContainerStyle}>
							<input
								id={optionId}
								type="checkbox"
								onClick={() => updateFilterObject(filterOptionName)}
								css={hiddenInputStyle}
							/>
							<span css={checkboxSpanStyle} className={active ? 'checked' : ''}>
								<span css={[iconSpanBaseStyle, active && iconSpanVisibleStyle]}>
									<Icon
										name="featurecheckmark"
										size="xs"
										color={wacToken('color.neutral.light0')}
									/>
								</span>
							</span>
							{filterOptionName}
						</label>
					);
				})}
			</div>
		</div>
	);
};

const uniformFilterModalStyle = css({
	position: 'absolute',
	backgroundColor: 'white',
	borderRadius: '20px',
	zIndex: 2,
	insetBlockStart: '55px',
	padding: '16px 24px 24px 24px',
	flexDirection: 'column',
	boxShadow: token('elevation.shadow.overlay'),
});

const filterRadioButtonContainerStyle = css({
	margin: '8px 0 0 0',
	cursor: 'pointer',
	display: 'flex',
	flexWrap: 'nowrap',
	alignItems: 'center',
	justifyContent: 'flex-start',
});

const checkboxSpanStyle = css({
	width: '20px',
	height: '20px',
	borderRadius: '3px',
	border: `2px solid ${wacToken('color.neutral.dark100')}`,
	flexBasis: '20px',
	marginInlineEnd: '8px',
	background: wacToken('color.neutral.light0'),
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	':hover': {
		border: `2px solid ${wacToken('color.primary.blue')}`,
	},
	'&.checked': {
		background: wacToken('color.primary.blue'),
		border: `2px solid ${wacToken('color.primary.blue')}`,
	},
});

const iconSpanBaseStyle = css({
	opacity: 0,
});

const iconSpanVisibleStyle = css({
	opacity: 1,
});

const hiddenInputStyle = css({
	position: 'absolute',
	opacity: 0,
	pointerEvents: 'none',
});

const filterListContainerStyle = css({
	display: 'flex',
	flexDirection: 'column',
});
